import { CircularProgress, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import useStyles from './styles'
import React, { useEffect } from 'react'
import { useSetorService } from 'hooks/useSetorService'
import { Autocomplete } from '@material-ui/lab'
import { useState } from 'react'
import { useCallback } from 'react'
import { SelecionarDataFutura } from '../SelecionarDataFutura'

export const FormSolicitacaoVestigio = (props) => {
  const { form, handleChange, setor, user } = props
  const setorService = useSetorService()
  const [processandoSetores, setProcessandoSetores] = useState(false)
  const [setores, setSetores] = useState([])
  const classes = useStyles()

  const fetchSetores = useCallback(async () => {
    const response = await setorService.listarSetoresAsync(setProcessandoSetores)
    const setoresUsuario = response.filter((setor) => user.setores.some((setorUsuario) => setorUsuario.id === setor.id))
    setSetores(setoresUsuario)
  }, [])

  useEffect(() => {
    fetchSetores()
    handleChange('setOrig', setor)
  }, [fetchSetores])

  return (
    <Grid container className={classes.container} spacing={3}>
      <Grid item md={12} sm={12} xs={12} lg={12}>
        <Typography className={classes.gridTitle}>
          <b>FORMULÁRIO DE SOLICITAÇÃO DE VESTÍGIO</b>
        </Typography>
      </Grid>

      {processandoSetores ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>
          <Grid item md={12} sm={12} xs={12}>
            <Autocomplete
              name="setDest"
              value={form.setDest}
              noOptionsText="Sem informações"
              options={setores}
              onChange={(event, newValue) => {
                handleChange('setDest', newValue)
              }}
              getOptionLabel={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
              renderOption={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="SETOR SOLICITANTE"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
              )}
            />
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              label="SETOR SOLICITADO"
              name="setOrig"
              //   onChange={(e) => handleChange('setorSolicitado', e.target.value)}
              value={setor?.nome}
              readOnly
              disabled
            />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <SelecionarDataFutura
              label="HORÁRIO DE RETIRADA DO VESTÍGIO"
              required
              maxDate={2}
              minutesStep={30}
              callback={(date) => {
                handleChange('data', date)
              }}
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}
